(function () {
    // Configuration object
    var injectionConfig = [

        // product page
        {
            slug: '/cell-being',
            utm_campaign: 'whiskey',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/shopify-header/andrew/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'neal',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/shopify-header/neal/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'dalton',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/shopify-header/dalton/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'thomas',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/morning-thomas/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'thomas',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/evening-thomas/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'Dan Wootton',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/evening-dan/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
       {
            slug: '/morning-being',
            utm_campaign: 'Dan Wootton',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/morning-dan/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'dannyjones',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/mb-danny/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'dannyjones',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/eb-danny/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'BROOKE',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/brooke/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'thomas',
            utm_content: 'newsletter',
            iframeUrl: 'https://go.ver.so/evening-thomas/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'JULIANDOREY',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/cellbeing-julian/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'RODICULOUS',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/cellbeing-rosana/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'TOE',
            utm_content: 'audiopodcast',
            iframeUrl: 'https://go.ver.so/cellbeing-toe/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },

        // new
        // thomas
        {
            slug: '/evening-being',
            utm_campaign: 'thomas-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-thomas/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'thomas-eb-newsletter',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-thomas/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'thomas-mb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/morning-thomas/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'thomas-cell',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/thomas-cell/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/clean-being',
            utm_campaign: 'thomas-clean',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/thomas-clean/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
                {
            slug: '/clean-being',
            utm_campaign: 'thomas-clean-dhq',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/thomas-clean-dhq/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },

        // danny
        {
            slug: '/evening-being',
            utm_campaign: 'danny-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/eb-danny/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'danny-mb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/mb-danny/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'danny-cell',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/danny-cell/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/clean-being',
            utm_campaign: 'danny-clean',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/danny-clean/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        // Dan Wootton
        {
            slug: '/evening-being',
            utm_campaign: 'wootton-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-dan/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'wootton-mb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/morning-dan/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        // Andrew Santino
        {
            slug: '/cell-being',
            utm_campaign: 'whiskey',
            iframeUrl: 'https://go.ver.so/shopify-header/andrew/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
        // Neal Brennan
        {
            slug: '/cell-being',
            utm_campaign: 'neal',
            iframeUrl: 'https://go.ver.so/shopify-header/neal/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
        // Dalton Fischer
        {
            slug: '/cell-being',
            utm_campaign: 'dalton',
            iframeUrl: 'https://go.ver.so/shopify-header/dalton/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
        // Theories of Everything
        {
            slug: '/cell-being',
            utm_campaign: 'toe',
            iframeUrl: 'https://go.ver.so/cellbeing-toe/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'toe-eb',
            iframeUrl: 'https://go.ver.so/toe-eb/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
        // Julian Dorey
        {
            slug: '/morning-being',
            utm_campaign: 'juliandorey-mb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/cellbeing-julian/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        // Rodiculous with Rosanna
        {
            slug: '/cell-being',
            utm_campaign: 'rodiculous-cell',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/cellbeing-rosana/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
        // Brooke Ashley
        {
            slug: '/cell-being',
            utm_campaign: 'brooke-cell',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/brooke/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'product'
        },
      // Florence Read / Unherd (Evening Being)
        {
            slug: '/evening-being',
            utm_campaign: 'unherd-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/eb-unherd/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
      // EmilyJashinky / Undercurrents (Evening  Being)
        {
            slug: '/evening-being',
            utm_campaign: 'undercurrents-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/eb-undercurrents/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },

      // Luke Caverns
        {
            slug: '/evening-being',
            utm_campaign: 'caverns-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-caverns/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'caverns-mb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/morning-caverns/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },

        // Triggernometry
        {
            slug: '/evening-being',
            utm_campaign: 'trigger-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-triggernometry/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'COX-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-cox/',
            pcHeight: 566, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },

          // Amy Dangerfield
        {
            slug: '/morning-being',
            utm_campaign: 'danger-mb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/mb-danger/',
            pcHeight: 652, // Default height for PC
            mobileHeight: 1200, // Default height for Mobile
            pageType: 'product'
        },

        // Lucas Aoun  
        {
            slug: '/evening-being',
            utm_campaign: 'lucas-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/eb-lucas-aoun/',
            pcHeight: 562, // Default height for PC
            mobileHeight: 953, // Default height for Mobile
            pageType: 'product'
        },
        // Quite Frankly (Evening Being)  
        {
            slug: '/evening-being',
            utm_campaign: 'FRANKLY-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/collection-quite-frankly/',
            pcHeight: 562, // Default height for PC
            mobileHeight: 953, // Default height for Mobile
            pageType: 'product'
        },

        // Dr. Ashley Froese
        {
            slug: '/evening-being',
            utm_campaign: 'froese-eb',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/eb-dr-ashley-froese/',
            pcHeight: 563, // Default height for PC
            mobileHeight: 807, // Default height for Mobile
            pageType: 'product'
        },

        // collection page
        {
            slug: '/best-selling-collection',
            utm_campaign: 'FRANKLY',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/collection-quite-frankly/',
            pcHeight: 566,
            mobileHeight: 1200,
            pageType: 'collection'
        },
        {
            slug: '/best-selling-collection',
            utm_campaign: 'thomas',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/shopify-header/thomas/',
            pcHeight: 566,
            mobileHeight: 700,
            pageType: 'collection'
        },

        {
            slug: '/best-selling-collection',
            utm_campaign: 'danny',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/danny-cell/',
            pcHeight: 563,
            mobileHeight: 844,
            pageType: 'collection'
        },
        {
            slug: '/best-selling-collection',
            utm_campaign: 'cox',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-cox/',
            pcHeight: 534,
            mobileHeight: 780,
            pageType: 'collection'
        },
        {
            slug: '/best-selling-collection',
            utm_campaign: 'wootton',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-dan/',
            pcHeight: 579,
            mobileHeight: 963,
            pageType: 'collection'
        },
        {
            slug: '/best-selling-collection',
            utm_campaign: 'triggernometry',
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/evening-triggernometry/',
            pcHeight: 565,
            mobileHeight: 773,
            pageType: 'collection'
        },

        // special
        { 
            slug: '/morning-being',
            utm_campaign: 'morning-being-iframe',    
            utm_source: 'referral',
            iframeUrl: 'https://go.ver.so/morning-being-inject-iframe/',
            pcHeight: 4040, // Default height for PC 
            mobileHeight: 4007, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        { 
            slug: '/morning-being',
            utm_campaign: 'morning-being-iframe-chocolate-is-bad',    
            utm_source: 'referral',
            iframeUrl: 'https://go.ver.so/morning-being-inject-iframe-chocolate-is-bad/',
            pcHeight: 3532, // Default height for PC 
            mobileHeight: 4432, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        { 
            slug: '/morning-being',
            utm_campaign: 'thomas-mb-cortisol',    
            utm_source: 'affiliate',
            iframeUrl: 'https://go.ver.so/morning-being-inject-iframe-stress/',
            pcHeight: 2900, // Default height for PC 
            mobileHeight: 2188, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        { 
            slug: '/cell-being',
            utm_campaign: 'cell-being-iframe-antiaging',    
            iframeUrl: 'https://go.ver.so/cell-being-inject-iframe-antiaging/',
            pcHeight: 3558, // Default height for PC 
            mobileHeight: 4535, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        { 
            slug: '/clean-being',
            utm_campaign: 'clean-being-iframe-fasting',    
            iframeUrl: 'https://go.ver.so/clean-being-inject-iframe-fasting/',
            pcHeight: 3567, // Default height for PC 
            mobileHeight: 4273, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        { 
            slug: '/clean-being',
            utm_campaign: 'clean-being-iframe-metabolism',    
            iframeUrl: 'https://go.ver.so/clean-being-inject-iframe-metabolism/',
            pcHeight: 3553, // Default height for PC 
            mobileHeight: 4375, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'evening-being-iframe-cortisol',
            iframeUrl: 'https://go.ver.so/evening-being-inject-iframe-cortisol/',
            pcHeight: 4438, // Default height for PC 
            mobileHeight: 1088, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'thomas-mb-cortisol',
            iframeUrl: 'https://go.ver.so/thomas-mb-cortisol/',
            pcHeight: 3032, // Default height for PC 
            mobileHeight: 1088, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        {
            slug: '/morning-being',
            utm_campaign: 'thomas-mb-flavanols',
            iframeUrl: 'https://go.ver.so/morning-being-inject-iframe-flavanols/',
            pcHeight: 2977, // Default height for PC 
            mobileHeight: 2461, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
       // special with only utm_campaign no utm_source
        {
            slug: '/cell-being',
            utm_campaign: 'cb-kb-nmn',
            iframeUrl: 'https://go.ver.so/cb-kb/',
            pcHeight: 722, // Default height for PC 
            mobileHeight: 1088, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        {
            slug: '/cell-being',
            utm_campaign: 'cell-being-iframe-skin-hair',
            iframeUrl: 'https://go.ver.so/cell-being-iframe-skin-hair/',
            pcHeight: 4136, // Default height for PC 
            mobileHeight: 5688, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
        {
            slug: '/evening-being',
            utm_campaign: 'evening-being-thomas-visceralfat',
            iframeUrl: 'https://go.ver.so/evening-being-inject-iframe-viseralfat/',
            pcHeight: 3485, // Default height for PC 
            mobileHeight: 2902, // Default height for Mobile 
            pageType: 'product',
            id: 'iframe_injection_long'
        },
    ];

    // Validate all config entries at runtime
    injectionConfig.forEach(function (config, index) {

        if (!config.pageType || !['product', 'collection'].includes(config.pageType)) {
            console.warn(
                `[iframe injector] ⚠️ Invalid or missing 'pageType' in config at index ${index}`,
                config
            );
        }

        if (!config.slug || !config.iframeUrl) {
            console.warn(`[iframe injector] ⚠️ Missing required config properties at index ${index}`, config);
        }
         
    });


    // Helper function to detect mobile device
    function isMobile() {
        return window.innerWidth <= 768;
    }

    //Helper function to Identify page type
    function getPageType(path) {
        if (path.includes('/products/')) return 'product';
        if (path.includes('/collections/')) return 'collection';
        return null;
    }

    // Parse URL and UTM parameters
    var currentUrl = window.location.pathname;
    var pageType = getPageType(currentUrl);
    if (!pageType) return;

    var urlParams = new URLSearchParams(window.location.search);

    var utm_campaign = urlParams.get('utm_campaign')??'';
    var utm_content = urlParams.get('utm_content')??'';
    var utm_source = urlParams.get('utm_source')??'';

    // console.log(currentUrl)
    // console.log(urlParams)
    // console.log(utm_campaign)
    // console.log(utm_content)
    // console.log(utm_source)

    // Find a matching configuration
    var match = injectionConfig.find(function (config) {
         // Check if 'utm_campaign' exists in the config before comparing
        var campaignMatches = config.utm_campaign ? config.utm_campaign.toLowerCase() === utm_campaign.toLowerCase() : true;
        // Check if 'utm_source' exists in the config before comparing
        var sourceMatches = config.utm_source ? config.utm_source.toLowerCase() === utm_source.toLowerCase() : true;
        // Check if 'utm_content' exists in the config before comparing
        var contentMatches = config.utm_content ? config.utm_content.toLowerCase() === utm_content.toLowerCase() : true;
        return (
            currentUrl.indexOf(config.slug) !== -1 &&
            campaignMatches &&
            sourceMatches &&
            contentMatches &&
            config.pageType === pageType
        );
    });

//    console.log(match)

    if (!match) {

        //  var specialParam = urlParams.get('special');
        //  console.log(specialParam);
        // if (specialParam) {
        //     match = injectionConfig.find(function (config) {
        //         return (
        //             config.special &&
        //             config.special.toLowerCase() === specialParam.toLowerCase() &&
        //             config.pageType === pageType
        //         );
        //     });
        // }
        
        // console.info(`[iframe injector] No matching config found for: ${pageType} page`, {
        //     path: currentUrl,
        //     utm_campaign,
        //     utm_content,
        //     utm_source
        // });
        return;
    }

    // Determine iframe height based on device
    var initialHeight = isMobile() ? (match.mobileHeight || 1200) : (match.pcHeight || 566);

    // Create the iframe element
    var iframe = document.createElement('iframe');
    iframe.src = match.iframeUrl;
    iframe.width = '100%';
    iframe.height = initialHeight;
    iframe.frameBorder = '0';
    iframe.allowFullscreen = true;
    iframe.style.cssText =
        'width: 100%; display: block; margin: 0 auto; background-color: transparent;'; // Placeholder background color
    if (match?.id) {
        iframe.id = match.id;
    }

    // Create the container div for the iframe
    var iframeContainer = document.createElement('div');
    iframeContainer.style.backgroundColor = 'transparent';
    iframeContainer.appendChild(iframe);

    // Find the #shopify-section-header element and insert the iframe container after it
    var headerSection = document.querySelector('.shopify-section.section-header');
    if (headerSection) {
        headerSection.parentNode.insertBefore(iframeContainer, headerSection.nextSibling);
    }

    // Timeout for fallback if no message received from iframe
    var iframeResizeTimeout = setTimeout(function () {
        // If no message is received within 3 seconds, use default height based on screen size
        var fallbackHeight = isMobile() ? (match.mobileHeight || 1200) : (match.pcHeight || 566);
            iframe.style.height = fallbackHeight +10 + 'px';
            iframeContainer.style.height = fallbackHeight +10 + 'px';
    }, 5660); // 3 seconds timeout for receiving the height message


    // Listen for messages from the iframe
    window.addEventListener('message', function (event) {
        // Ensure the message is coming from the correct origin dynamically
        if (event.origin != new URL(match.iframeUrl).origin) return;

        //console.log(event);
        var data = JSON.parse(event.data);
        // console.log(data);
      

        if (data.event == 'size' && data.height) {
            iframe.style.height = data.height +10 + 'px';
            iframeContainer.height =  data.height+10 + 'px';
            // Clear the timeout if height message is received
            clearTimeout(iframeResizeTimeout);
        }
    });

})();

document.addEventListener('DOMContentLoaded', function () {
    // Listen for messages from the iframe
    window.addEventListener('message', function (event) {
        const header = document.querySelector('header');
        // const headerH = header ? header.offsetHeight : 0;
        const headerH =  0;
        const buyBox = document.querySelector('.product');
        // Ensure the message is coming from the correct origin dynamically
        // console.log(event);
        // console.log(buyBox);
        if (event.origin != 'https://go.ver.so') return;


        // console.log(event);
        var data = event.data? JSON.parse(event.data):false;
        // console.log(data)
      

        if (data && data.event == 'go-to-buy-box' ) {
            if (!buyBox) return;
            const y = buyBox.getBoundingClientRect().top + window.scrollY - headerH ;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    });
});